import api from '../../../services/api';

/**
 * Fetch commercials cost estimation
 */
export const fetchCommercialsCostEstimation = async (rfpId) => {
    return api.get(`/extraction/v1/${rfpId}/commercials/cost-estimation`);
};

/**
 * Download commercials cost estimation as Excel
 */
export const downloadCommercialsCostEstimation = async (rfpId) => {
    return api.get(`/extraction/v1/${rfpId}/commercials/cost-estimation/download`, {
        responseType: 'blob'
    });
};

/**
 * Update commercials cost estimation
 */
export const updateCommercialsCostEstimation = async (rfpId, payload) => {
    return api.put(`/extraction/v1/${rfpId}/commercials/cost-estimation`, payload);
};
